define((require) => {
    "use strict";

    const CompositeWidgetPropertiesView  = require("ui/experience/widgets/compositeWidget/CompositeWidgetPropertiesView");
    const template                       = require("ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetPropertiesView.tpl");
    const SizeAndPositionPropertiesView  = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const ProductPropertiesView          = require("ui/experience/widgets/dynamicProductWidget/ProductPropertiesView");


    const EXPAND_PROPERTY = "dynamicProductExpanded";

    /**
     * The properties view for a dynamic product widget which extends a composite widget.
     *
     * @class DynamicWidgetPropertiesView
     * @constructor
     *
     * @cfg {DynamicProductWidgetModel} model The model for the composite widget being edited.
     */
    return CompositeWidgetPropertiesView.extend("DynamicWidgetPropertiesView", {
        template,

        ui: {
            container: ".dynamic-widget-properties-accordion"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            productProperties: ".product-properties"
        },

        onRender: function() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                hideSizeControls: true,
                hideRotation: true,
                hideGrouping: true,
                widgetView: this.options.widgetView
            }));
            this.productProperties.show(new ProductPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetPropertiesView.js